<rappider-schema-tree-select #treeSelectComponent
                             [tree]="tree"
                             [ngModel]="operationFieldKey"
                             [multipleSelect]="false">
</rappider-schema-tree-select>
